<div class="fixed z-40 inset-0 flex items-center justify-center">
  <div class="absolute inset-0 bg-slate-900 bg-opacity-60"></div>
  <div class="relative bg-slate-100 border-2 border-slate-100 rounded overflow-hidden max-w-xl w-full m-4">
    <div class="relative flex items-center px-4 py-4">
      <p class="absolute inset-x-0 text-green-600 text-center">{{heading()}}</p>
      <div (click)="close()"
        class="flex items-center justify-center rounded cursor-pointer aspect-square w-10 h-10 z-20 ml-auto border border-slate-200 bg-slate-50 hover:bg-white text-green-600">
        <i class="fa-solid fa-xmark"></i>
      </div>
    </div>
    <div class="max-h-[60vh] overflow-y-auto px-4 pb-4">
      <ng-template #contents></ng-template>
    </div>
  </div>
</div>